import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

import ListData from './components/listData';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export default function PSToHonda() {
    return (
        <Box sx={{ flexGrow: 1, m: 1 }}>
            {/* <Grid container spacing={2}>
                <Grid   > */}
            <ListData />
            {/* </Grid> */}

            {/* </Grid> */}
        </Box>
    );
}